import Quill, { type Parchment } from 'quill'

import { IMAGE_ALIGN_ATTRIBUTE } from './ImageAlignment'

const ImageBlot = Quill.import('formats/image') as typeof Parchment.EmbedBlot

export class CustomImage extends ImageBlot {
  blotName = 'image'
  tagName = 'IMG'

  static create(src: string) {
    const node = super.create(src)
    return node
  }

  static formats(domNode: HTMLElement): Record<string, string | null> {
    return {
      'data-id': domNode.getAttribute('data-id'),
      width: domNode.getAttribute('width'),
      height: domNode.getAttribute('height'),
      [IMAGE_ALIGN_ATTRIBUTE]: domNode.getAttribute(IMAGE_ALIGN_ATTRIBUTE),
    }
  }

  format(name: string, value: string | null) {
    const domNode = this.domNode as HTMLElement

    // Image id
    if (name === 'data-id') {
      if (value) domNode.setAttribute('data-id', value)
      else domNode.removeAttribute('data-id')
    }

    // Width, height and alignment
    else if (
      name === 'width' ||
      name === 'height' ||
      name === IMAGE_ALIGN_ATTRIBUTE
    ) {
      if (value) domNode.setAttribute(name, value)
      else domNode.removeAttribute(name)
    }

    // Fallback
    else {
      super.format(name, value)
    }
  }
}
